var React = require('react');

function RadioEmpty (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"12","cy":"12","r":"9","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square"}));
}

RadioEmpty.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = RadioEmpty;

RadioEmpty.default = RadioEmpty;
